import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SalesItemsPriceChanges, SalesPriceChanges } from "tilby-models";

export type PriceChangesType = SalesItemsPriceChanges.TypeEnum | SalesPriceChanges.TypeEnum;
export type PriceChange = Pick<SalesItemsPriceChanges & SalesPriceChanges, 'description' | 'value' | 'type'>;
export type PriceChangeDescriptionObj = Record<PriceChangesType, { label: string; printParams?: true }>;

@Pipe({
  name: 'tilbyPriceChange',
  standalone: true,
})
export class TilbyPriceChangePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(priceChange: PriceChange, priceChangeDescriptionsObj: PriceChangeDescriptionObj): string {
    if (!priceChange) {
      return '';
    }

    const { description, type, value } = priceChange;

    const config = type
      ? priceChangeDescriptionsObj[type as PriceChangesType]
      : null;

    if (!description && config) {
      return this.translateService.instant(config.label || '', config.printParams ? { value } : undefined);
    }

    const isPercentage = type?.endsWith('perc');

    if (isPercentage) {
      return description
        ? `${description} (${value}%)`
        : `(${value}%)`;
    }

    return description || '';
  }
}